import CheckLawfulFrame from './CheckLawfulFrame';

export default CheckLawfulFrame;
